// File: frontend/src/components/upload/FileUploadZone.js

import React, { useRef, useState } from 'react';
import { Upload, FileText, Sparkles } from 'lucide-react';
import styles from './FileUploadZone.module.css';

const FileUploadZone = ({ onFileSelect, error }) => {
  const fileInputRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);

  const handleDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);

    const files = e.dataTransfer.files;
    if (files && files.length > 0) {
      onFileSelect(files[0]);
    }
  };

  const handleFileInputChange = (e) => {
    const files = e.target.files;
    if (files && files.length > 0) {
      onFileSelect(files[0]);
    }
  };

  const handleClick = () => {
    fileInputRef.current?.click();
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleClick();
    }
  };

  return (
    <div className={styles.uploadZone}>
      <div
        className={`${styles.dropZone} ${isDragging ? styles.dragging : ''} ${error ? styles.error : ''}`}
        onDragEnter={handleDragEnter}
        onDragLeave={handleDragLeave}
        onDragOver={handleDragOver}
        onDrop={handleDrop}
        onClick={handleClick}
        onKeyDown={handleKeyDown}
        role="button"
        tabIndex={0}
        aria-label="Upload insurance policy PDF"
      >
        <input
          ref={fileInputRef}
          type="file"
          accept="application/pdf"
          onChange={handleFileInputChange}
          className={styles.fileInput}
          aria-hidden="true"
        />

        <div className={styles.uploadIcon}>
          <Upload size={48} strokeWidth={2} />
        </div>

        <h3 className={styles.uploadTitle}>
          {isDragging ? 'Drop your file here' : 'Drag & drop your policy PDF'}
        </h3>

        <p className={styles.uploadSubtitle}>
          or <span className={styles.browseLink}>browse files</span>
        </p>

        <div className={styles.uploadHints}>
          <div className={styles.hint}>
            <FileText size={16} strokeWidth={2} />
            <span>PDF files only</span>
          </div>
          <div className={styles.hint}>
            <Sparkles size={16} strokeWidth={2} />
            <span>Max 50MB</span>
          </div>
          <div className={styles.hint}>
            <Sparkles size={16} strokeWidth={2} />
            <span>AI-powered extraction</span>
          </div>
        </div>
      </div>

      {error && (
        <div className={styles.errorMessage} role="alert">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
            <path
              d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM11 15H9V13H11V15ZM11 11H9V5H11V11Z"
              fill="currentColor"
            />
          </svg>
          <span>{error}</span>
        </div>
      )}
    </div>
  );
};

export default FileUploadZone;